'use strict';

import { Entity } from '../Entity';

export class IndHealth extends Entity {
  protected indHealthId;

  protected ind;

  protected indHeightFoot;

  protected indHeightInch;

  protected indWeight;

  protected indTobacco;

  protected indHealthNotes;

  protected dnr;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indHealthId = data.indHealthId;

    this.ind = data.ind;

    this.indHeightFoot = data.indHeightFoot;

    this.indHeightInch = data.indHeightInch;

    this.indWeight = data.indWeight;

    this.indTobacco = data.indTobacco;

    this.indHealthNotes = data.indHealthNotes;

    this.dnr = data.dnr;
  }

  public getIndHealthId() {
    return this.indHealthId;
  }

  public setIndHealthId(indHealthId) {
    this.indHealthId = indHealthId;
    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;
    return this;
  }

  public getIndHeightFoot() {
    return this.indHeightFoot;
  }

  public setIndHeightFoot(indHeightFoot) {
    this.indHeightFoot = indHeightFoot;

    return this;
  }

  public getIndHeightInch() {
    return this.indHeightInch;
  }

  public setIndHeightInch(indHeightInch) {
    this.indHeightInch = indHeightInch;

    return this;
  }

  public getIndWeight() {
    return this.indWeight;
  }

  public setIndWeight(indWeight) {
    this.indWeight = indWeight;

    return this;
  }

  public getIndTobacco() {
    return this.indTobacco;
  }

  public setIndTobacco(indTobacco) {
    this.indTobacco = indTobacco;

    return this;
  }

  public getIndHealthNotes() {
    return this.indHealthNotes;
  }

  public setIndHealthNotes(indHealthNotes) {
    this.indHealthNotes = indHealthNotes;

    return this;
  }

  public getDnr() {
    return this.dnr;
  }

  public setDnr(dnr) {
    this.dnr = dnr;

    return this;
  }
}
